import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen gradient-mesh py-12 px-4">
      <div className="container mx-auto max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-8 hover:bg-primary/10"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück
        </Button>

        <div className="prose prose-sm md:prose-base max-w-none">
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground mb-8">
            Datenschutzerklärung
          </h1>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Allgemeine Hinweise
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Datenerfassung auf dieser Website
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
              Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              <strong>Wie erfassen wir Ihre Daten?</strong>
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann
              es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder uns per
              WhatsApp oder E-Mail zusenden.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website
              durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
              Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              2. Hosting
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </p>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Externes Hosting
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website
              erfasst werden, werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei
              kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten,
              Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine
              Website generiert werden, handeln.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Datenschutz
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
              behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
              Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
              sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Hinweis zur verantwortlichen Stelle
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Fuel72 ist eine Marke von:<br /><br />
              <strong>FUEGODROPS GmbH</strong><br />
              Sitz: Bad Honnef<br />
              53604 Bad Honnef<br />
              Deutschland
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Handelsregister: Amtsgericht Siegburg, HRB 18191
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              E-Mail: hello@fuel72.com<br />
              WhatsApp: +49 176 87870011
            </p>
            <div className="p-4 rounded-xl border border-neon-cyan/30 bg-neon-cyan/5 mb-4">
              <p className="text-muted-foreground leading-relaxed">
                <strong>Für US-Kunden / For US Customers:</strong><br />
                FUEGODROPS LLC<br />
                State of Wyoming<br />
                United States
              </p>
            </div>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
              gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
              Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Speicherdauer
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
              wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
              Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder
              eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
              wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
              personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
              Aufbewahrungsfristen).
            </p>
          </section>

          <section className="mb-8">
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Ihre Rechte
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck
              Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht,
              die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
              Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft
              widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung
              der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns
              wenden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              4. Datenerfassung auf dieser Website
            </h2>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              Kontaktaufnahme
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Wenn Sie uns per E-Mail, WhatsApp oder über ein Kontaktformular kontaktieren, werden
              Ihre Angaben inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
              der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben
              wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
              sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
              vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die
              Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns
              gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6
              Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-4">
              5. Soziale Medien
            </h2>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-3">
              WhatsApp
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Wir bieten die Möglichkeit, mit uns über WhatsApp in Kontakt zu treten. Anbieter ist die
              WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
              Die Datenverarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a
              DSGVO), sofern Sie uns diese erteilt haben. Die Datenübertragung in Drittländer erfolgt
              auf Grundlage von Standardvertragsklauseln der EU-Kommission (Art. 46 Abs. 2 lit. c
              DSGVO).
            </p>
          </section>

          <p className="text-sm text-muted-foreground mt-12">
            Stand: {new Date().toLocaleDateString("de-DE")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
